import { Mark, markInputRule, markPasteRule } from "@tiptap/core";

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        highlight: {
            setHighlight: (color: string) => ReturnType,
            toggleHighlight: (color: string) => ReturnType,
            unsetHighlight: () => ReturnType,
        }
    }
}

export const Highlight = Mark.create({
    name: "highlight",
    group: 'inline',
    content: 'inline*',

    addOptions() {
        return {
            HTMLAttributes: {
                class: 'highlight',
            },
            color: 'yellow', // Default color
        };
    },

    parseHTML() {
        return [
            {
                tag: 'mark',
            },
            {
                tag: 'span',
                getAttrs: (node) => {
                    if (typeof node === 'string') return false;
                    const style = node.style.backgroundColor

                    return style ? { color: style } : false;
                },
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        const { color } = this.options;
        HTMLAttributes.style = `background-color: ${color};`;
        return ['mark', HTMLAttributes, 0];
    },

    addCommands() {
        return {
            setHighlight:
                (color) =>
                    ({ commands }) => {
                        this.options.color = color; // Set the color option
                        return commands.setMark(this.name, { color });
                    },
            toggleHighlight:
                (color) =>
                    ({ commands }) => {
                        this.options.color = color; // Set the color option
                        return commands.toggleMark(this.name, { color });
                    },
            unsetHighlight:
                () =>
                    ({ commands }) => {
                        return commands.unsetMark(this.name);
                    },
        };
    },

    addInputRules() {
        return [
            markInputRule({
                find: /==([^=]+)==$/,
                type: this.type,
            }),
        ];
    },

    addPasteRules() {
        return [
            markPasteRule({
                find: /==([^=]+)==/g,
                type: this.type,
            }),
        ];
    },
});